<template>
  <div>
    <back-btn />
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="workplaceData === undefined"
    >
      <h4 class="alert-heading">
        Erro ao buscar institution data
      </h4>
      <div class="alert-body">
        No institution found with this institution id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'institutions-list'}"
        >
          Institution List
        </b-link>
        for other institutions.
      </div>
    </b-alert>
    <b-card>
      <div class="physician-form">
        <template v-if="workplaceData">
          <div class="physician-form">
            <b-tabs
              pills
            >
              <b-tab active>
                <template #title>
                  <div>
                    <feather-icon
                      icon="UserIcon"
                      size="16"
                      class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Geral</span>
                  </div>
                </template>

                <b-row>
                  <b-col
                    cols="12"
                    md="12"
                    xl="8"
                  >
                    <b-form-group
                      label="Nome"
                      label-for="name"
                    >
                      <div id="name">
                        {{ workplaceData.name }}
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    cols="12"
                    md="12"
                    xl="8"
                  >
                    <div class="d-flex">
                      <feather-icon
                        icon="DollarSignIcon"
                        size="19"
                      />
                      <h4 class="mb-0 ml-50 mb-1">
                        Pagamento
                        <small class="text-muted">
                          dia {{ workplaceData.payday || 'X' }} a cada {{ workplaceData.payment_month || 'X' }} meses
                        </small>
                      </h4>
                    </div>
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Dia de pagamento"
                          label-for="payday"
                        >
                          <div>{{ workplaceData.payday }}</div>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Mês competência"
                          label-for="payment_month"
                        >
                          {{ workplaceData.payment_month }}
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    cols="12"
                    md="12"
                    xl="8"
                  >
                    <div class="d-flex">
                      <feather-icon
                        icon="MailIcon"
                        size="19"
                      />
                      <h4 class="mb-0 ml-50 mb-1">
                        Endereço
                      </h4>
                    </div>
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Contato"
                          label-for="contato"
                        >
                          {{ workplaceData.contact }}
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Telefone"
                          label-for="telefone"
                        >
                          {{ formatPhone(workplaceData.phone) }}
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="CEP"
                          label-for="CEP"
                        >
                          <div>{{ workplaceData.address.postal_code }}</div>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Estado"
                          label-for="state"
                        >
                          <div>{{ workplaceData.address.city.state.abbreviation }}</div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Cidade"
                          label-for="cidade"
                        >
                          <div>{{ workplaceData.address.city.name }}</div>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Bairro"
                          label-for="bairro"
                        >
                          <div>{{ workplaceData.address.neighborhood }}</div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group
                          label="Rua"
                          label-for="rua"
                        >
                          <div>{{ workplaceData.address.street }}</div>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group
                          label="Número"
                          label-for="número"
                        >
                          <div>{{ workplaceData.address.number }}</div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-form-group
                      label="Complemento"
                      label-for="complemento"
                    >
                      <div>{{ workplaceData.address.complement || '-' }}</div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>

              <b-tab

                class="tab-duty"
              >
                <template #title>
                  <div>
                    <feather-icon
                      icon="DollarSignIcon"
                      size="16"
                      class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">
                      Tipos
                    </span>
                  </div>
                </template>

                <b-row>
                  <b-card
                    v-for="(duty, i) in workplaceData.duties"
                    :key="`duty-${duty.id}`"
                    overlay
                    no-body
                    class="my-1 ml-1 p-1 border"
                  >
                    <b-col
                      cols="12"
                      md="12"
                    >
                      <b-form-group
                        label="Profissão"
                        :label-for="`profession_id-${duty.id}`"
                      >
                        <div>{{ duty.profession_label }}</div>
                      </b-form-group>
                      <b-form-group
                        label="Especialidade"
                        :label-for="`duty_type_id-${duty.id}`"
                      >
                        <div>{{ duty.duty_type }}</div>
                      </b-form-group>
                      <b-form-group
                        label="Tipo complemento"
                        :label-for="`duty_type_complement-${duty.id}`"
                      >
                        <div>{{ duty.complement || '-' }}</div>
                      </b-form-group>
                      <div
                        v-for="(remuneration, index) in Object.keys(duty.remuneration)"
                        :key="`remuneration-${duty.id}-${index}`"
                      >
                        <b-form-group>
                          <label
                            :for="`duty-${i}`"
                            class="d-block duty-label"
                          >
                            Valor hora <b>{{ getRemunerationType(remuneration) }}</b> <br><span class="text-muted">({{ getNumberAsText(duty.remuneration[remuneration]) || 'zero reais' }})</span>
                          </label>
                          <div>{{ formatCurrencyInt(duty.remuneration[remuneration]) }}</div>
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-card>
                </b-row>
              </b-tab>

              <b-tab>
                <template #title>
                  <div>
                    <feather-icon
                      icon="UsersIcon"
                      size="16"
                      class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">
                      CNPJ Profissionais
                    </span>
                  </div>
                </template>

                <b-row>
                  <b-card no-body>
                    <b-card-body>
                      <b-table
                        ref="refWorkplaceListTable"
                        class="position-relative"
                        :items="workplaceData.physician_companies"
                        responsive
                        :fields="tableColumns"
                        primary-key="id"
                        show-empty
                        empty-text="Nenhum registro correspondente encontrado"
                      >
                        <template #cell(status)="{item}">
                          <b-badge
                            pill
                            :variant="item.status === 'approved' ? 'light-success' : 'light-primary'"
                          >
                            {{ getPhysicianStatus(item.status) }}
                          </b-badge>
                        </template>
                      </b-table>
                    </b-card-body>
                  </b-card>
                </b-row>
              </b-tab>
            </b-tabs>
          </div>
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import store from '@/store'
import slugify from 'slugify'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BAlert, BLink, BRow, BCol, BTabs, BTab, BFormGroup, BCard, BCardBody, BTable, BBadge,
} from 'bootstrap-vue'
import BackBtn from '@core/components/navigation/BackBtn.vue'
import {
  numberAsText, formatCnpj, formatCurrencyInt, formatPhone, formatCpf,
} from '@core/utils/utils'
import storeModule from '../../workplaceStoreModule'

export default {
  components: {
    BAlert,
    BLink,
    BackBtn,
    BRow,
    BCol,
    BTabs,
    BTab,
    BFormGroup,
    BCard,
    BCardBody,
    BTable,
    BBadge,
  },
  methods: {
    formatCpf,
    formatPhone,
    formatCurrencyInt,
    formatCnpj,
    getNumberAsText: numberAsText,
  },
  setup() {
    const workplaceData = ref(null)
    const professionOptions = ref([])
    const tableColumns = [
      { key: 'physician_company.cnpj', label: 'CNPJ', formatter: formatCnpj },
      { key: 'physician_company.name', label: 'Empresa' },
      { key: 'physician.name', label: 'Profissional' },
      { key: 'physician.cpf', label: 'CPF', formatter: formatCpf },
      { key: 'status', label: 'Status' },
    ]
    const getPhysicianStatus = status => {
      if (status === 'active') {
        return 'Ativo'
      }
      if (status === 'denied') {
        return 'Recusado'
      }
      return status === 'approved' ? 'Aprovado' : 'Pendente'
    }

    const STORE_MODULE_NAME = 'app-workplace'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const getDutyId = duty => `${duty.duty_type_id}-${duty.profession_id}${slugify(duty.complement || '', { lower: true })}`

    store.dispatch(`${STORE_MODULE_NAME}/fetchWorkplace`, { id: router.currentRoute.params.id })
      .then(response => {
        const duties = {}
        response.data.data.duties.forEach(duty => {
          if (!duties[getDutyId(duty)]) {
            duties[getDutyId(duty)] = {
              id: uuidv4(),
              profession_id: duty.profession_id,
              profession_label: duty.profession.label,
              duty_type: duty.duty_type,
              duty_type_id: duty.duty_type_id,
              service_type: duty.service_type,
              complement: duty.complement,
              remuneration: {
                week: 0,
                weekend: 0,
              },
            }
          }
          const remuneration = duty.remuneration / 100
          const formatted = String(remuneration).replace('.', ',')
          duties[getDutyId(duty)].remuneration[duty.value_modifier_type] = formatted
        })
        const data = {
          ...response.data.data,
          duties: Object.values(duties),
          address: response.data.data.address && response.data.data.address[0],
        }

        workplaceData.value = data
      })
      .catch(error => {
        if (error.response.status === 404) {
          workplaceData.value = undefined
        }
      })

    function getRemunerationType(type) {
      if (type === 'week') return 'dia de semana'
      return 'final de semana'
    }

    return {
      tableColumns,
      getPhysicianStatus,
      getRemunerationType,
      workplaceData,
      professionOptions,
      payDayOptions: [],
      paymentMonthOptions: [],
      stateOptions: [],
      selectedState: null,
      selectedCity: null,
      dutyTypesOptions: [],
    }
  },
}
</script>

<style>
.tab-duty {
  label {
    font-weight: bold;
  }
}
.duty-label {
  .text-muted {
    font-size: 10px!important;
  }
}
</style>
